export default {
  name: 'MicrosoftMarketplaceSuccess',

  computed: {
    has_token() {
      return Boolean(localStorage.getItem('token'));
    },
  },

  methods: {
    go_to_login() {
      this.$router.push({ name: 'Login' });
    },

    go_to_dashboard() {
      this.$router.push({ path: '/home' });
    },
  },
};
